import DashboardGiftCardsV2 from './DashboardGiftCardsV2';

export default DashboardGiftCardsV2;
